import { call, put, select } from "redux-saga/effects";
import { routes } from "../../common/api/routes";
import {
  fetchPromptStatus,
  fetchPromptStatusError,
  fetchPromptStatusSuccess,
} from "../actions/promptActions";

export function* fetchPromptStatusSaga() {
  const { isLoading, fetchAttempted } = yield select(
    (state) => state.promptReducer
  );

  if (isLoading || fetchAttempted) {
    return;
  }

  yield put(fetchPromptStatus());
  try {
    const response = yield call(routes.promptStatus);
    const latest = yield select((state) => state.promptReducer);
    if (latest.fetchAttempted) {
      return;
    }
    yield put(fetchPromptStatusSuccess(response));
  } catch {
    const latest = yield select((state) => state.promptReducer);
    if (!latest.fetchAttempted) {
      yield put(fetchPromptStatusError());
    }
  }
}

export function* logPromptSaga({ payload }) {
  try {
    yield call(routes.promptLog, payload);
  } catch {
    // Prompt logging should never block the UI.
  }
}
